import { Injectable } from '@angular/core';
import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable({
  providedIn: 'root'
})
export class GroupHasFrontProfileService extends RestfulService<Models.GroupHasFrontProfile> {

  constructor(private restService: RestService) {
    super(Models.GroupHasFrontProfile);

    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('group-has-front-profiles');
  }
}
